import { isNil } from './nil';
export function mapNonNil(value, mapper) {
    return isNil(value) ? value : mapper(value);
}
//# sourceMappingURL=general.js.map